"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.helicobacterPyloriMessages = exports.diseasesMessages = exports.HelicobacterPylori = exports.Diseases = void 0;
const schema_1 = require("../../../../../schema");
var Diseases;
(function (Diseases) {
    Diseases["GASTRIC_OR_DUODENAL_ULCER"] = "gastric_or_duodenal_ulcer";
    Diseases["ULCERATIVE_COLITIS"] = "ulcerative_colitis";
    Diseases["CROHNS_DISEASE"] = "crohns_disease";
    Diseases["PANCREATITIS"] = "pancreatitis";
    Diseases["CHOLECYSTITIS"] = "cholecystitis";
    Diseases["CHOLELITHIASIS"] = "cholelithiasis";
    Diseases["OTHER"] = "other";
})(Diseases || (exports.Diseases = Diseases = {}));
var HelicobacterPylori;
(function (HelicobacterPylori) {
    HelicobacterPylori["POSITIVE"] = "POSITIVE";
    HelicobacterPylori["NEGATIVE"] = "NEGATIVE";
})(HelicobacterPylori || (exports.HelicobacterPylori = HelicobacterPylori = {}));
exports.diseasesMessages = {
    [Diseases.GASTRIC_OR_DUODENAL_ULCER]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.GASTRIC_OR_DUODENAL_ULCER",
        defaultMessage: "Gyomor- vagy nyombélfekély"
    },
    [Diseases.ULCERATIVE_COLITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.ULCERATIVE_COLITIS",
        defaultMessage: "Colitis ulcerosa"
    },
    [Diseases.CROHNS_DISEASE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.CROHNS_DISEASE",
        defaultMessage: "Crohn-betegség"
    },
    [Diseases.PANCREATITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.PANCREATITIS",
        defaultMessage: "Pancreatitis"
    },
    [Diseases.CHOLECYSTITIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.CHOLECYSTITIS",
        defaultMessage: "Cholecystitis"
    },
    [Diseases.CHOLELITHIASIS]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.CHOLELITHIASIS",
        defaultMessage: "Cholelithiasis (epekőbetegség)"
    },
    [Diseases.OTHER]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.diseases.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.helicobacterPyloriMessages = {
    [HelicobacterPylori.POSITIVE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.helicobacterPylori.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HelicobacterPylori.NEGATIVE]: {
        id: "ltx.phaseI.medicalHistory.comorbidities.gastrointestinalDiseases.helicobacterPylori.NEGATIVE",
        defaultMessage: "Negatív"
    }
};
const diseases = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Diseases.GASTRIC_OR_DUODENAL_ULCER),
    schema_1.Schema.singleChoiceItem(Diseases.ULCERATIVE_COLITIS),
    schema_1.Schema.singleChoiceItem(Diseases.CROHNS_DISEASE),
    schema_1.Schema.singleChoiceItem(Diseases.PANCREATITIS),
    schema_1.Schema.singleChoiceItem(Diseases.CHOLECYSTITIS),
    schema_1.Schema.singleChoiceItem(Diseases.CHOLELITHIASIS),
    schema_1.Schema.singleChoiceItem(Diseases.OTHER)
]).interpretation({ vocab: "ltx", code: "gastrointestinal_disease" });
const helicobacterPylori = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../diseases} === "gastric_or_duodenal_ulcer"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HelicobacterPylori.POSITIVE),
    schema_1.Schema.singleChoiceItem(HelicobacterPylori.NEGATIVE)
]).interpretation({ vocab: "ltx", code: "helicobacter_pylori" }));
const comment = schema_1.Schema.string()
    .optional()
    .maxLength(1000)
    .interpretation({ vocab: "ltx", code: "gastrointestinal_disease_comment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ diseases, helicobacterPylori, comment })
    .interpretation({ vocab: "ltx", code: "gastrointestinal_disease_form" });
